<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    @ok="handleOk"
    :closable="info.status"
    :maskClosable="info.status"
    :footer="null"
    @cancel="handleCancel">
    <div>
      <div class="container">
        <!-- 顶部标题区域 -->
        <header id="header">
          <h1>{{info.title}}</h1>
          <div class="header-meta">
            <span>📅 发布日期: {{info.createTime}}</span>
<!--            <span>👤 作者: 项目管理部</span>-->
          </div>
        </header>

        <!-- 中间富文本内容区域 -->
        <main>
          <div class="rich-text" v-html="$filterXRichtext(info.content)">

          </div>
        </main>

        <!-- 底部附件列表区域 -->
        <footer >
          <h3 v-if="info.files">📎 相关附件</h3>
          <div class="attachment-list" v-if="info.files">
            <!-- 附件1 -->
            <div class="attachment-item" v-for="item in info.files.split(',')">
              <div class="attachment-info">
                <div class="attachment-icon" :class="getFilesName(item)">{{getFilesName(item)}}</div>
                <div class="attachment-details">
                  <h4>{{getFilesNameStr( item)}}</h4>
                </div>
              </div>
              <button class="download-btn" @click="handleDownload(item)">↓ 下载</button>
            </div>
          </div>
          <!-- 新增按钮区域 -->
          <div class="button-group" v-if="!info.status">
            <button class="later-btn" v-if="checkLater()" id="laterBtn" @click="handleLater">稍后处理</button>
            <button class="confirm-btn" id="confirmBtn" @click="handleOk">确认</button>
          </div>
        </footer>
      </div>
    </div>
  </j-modal>
</template>

<script>
import {httpAction, getAction, getFileAccessHttpUrl} from '@/api/manage'
import { Modal } from 'ant-design-vue'
import { mapActions } from "vuex"
  export default {
    name: 'MyNoticeModal',
    components: {

    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,
        info:{

        }
      }
    },
    methods: {
      ...mapActions(['Logout']),
      show (id) {
        if(id){
          getAction("/dm/dmEmployeeConfim/getByNoticeId",{noticeId:id}).then((res)=>{
            if(res.success && res.result && res.result.id){
              this.visible=true
              this.info = res.result
            }
          })
        }else{
          getAction("/dm/dmEmployeeNotice/getLastOne").then((res)=>{
            if(res.success && res.result && res.result.id){
              this.visible=true
              this.info = res.result
            }
          })
        }

      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        httpAction("/dm/dmEmployeeConfim/add",{
          noticeId:this.info.id,
          status:1
        },"POST").then(res=>{
          if(res.success){
            this.close();
          }
        })
      },checkLater(){
        let dat = new Date(this.info.endTime);
        if(dat.getTime()<new Date().getTime()){
          return false;
        }
        return true;
      },handleLater(){
        let dat = new Date(this.info.endTime);
        if(dat.getTime()<new Date().getTime()){
          // Modal.confirm({
          //   title: '提示',
          //   content: '是否继续，继续操作的话将冻结账号？',
          //   okText: '继续',
          //   cancelText: '取消',
          //   okType: 'danger', // 确认按钮为危险样式（红色）
          //   icon: 'exclamation-circle', // 显示警告图标
          //   onOk: () => {
          //     httpAction("/dm/dmEmployeeConfim/add",{
          //       noticeId:info.id,
          //       status:2
          //     },"POST").then(res=>{
          //       if(res.success){
          //         this.Logout().then(() => {
          //           this.$router.push({ path: '/user/login' });
          //         })
          //       }
          //     })
          //   }
          // });
        }else{
          this.close();
        }
      },
      handleCancel () {
        this.close()
      },getFilesName(fileName){
        return fileName.substring(fileName.lastIndexOf('.')+1).toUpperCase();
      },getFilesNameStr(fileName){
        if(fileName.indexOf('/')==-1){
          return fileName;
        }
        return fileName.substring(fileName.lastIndexOf('/')+1);
      },handleDownload(text){
        if(!text){
          this.$message.warning("未知的文件")
          return;
        }
        let url = getFileAccessHttpUrl(text)
        window.open(url);
      }
    }
  }
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

body {
  background-color: #f8f9fa;
  color: #333;
  line-height: 1.6;
  scroll-behavior: smooth;
}

/* 容器样式 */
.container {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  box-shadow: 0 0 10px rgba(0,0,0,0.05);
}

/* 顶部标题区域 */
header {
  border-bottom: 1px solid #eee;
  padding: 25px 40px;
  background: white;
  position: sticky;
  top: 0;
  transition: padding 0.3s ease;
}

header h1 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 10px;
}

.header-meta {
  color: #7f8c8d;
  font-size: 0.9rem;
  display: flex;
  gap: 20px;
}

.header-meta span {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 中间富文本内容区域 */
main {
  padding: 30px 40px;
}

.rich-text {
  color: #444;
}

.rich-text p {
  margin-bottom: 18px;
  line-height: 1.8;
}

.rich-text h2 {
  color: #2c3e50;
  margin: 25px 0 15px;
  font-size: 1.4rem;
  padding-bottom: 5px;
  border-bottom: 1px solid #f1f1f1;
}

.rich-text ul {
  margin: 0 0 18px 25px;
}

.rich-text li {
  margin-bottom: 8px;
}

.rich-text blockquote {
  border-left: 3px solid #3498db;
  padding: 10px 15px;
  margin: 20px 0;
  background: #f8f9fa;
  color: #7f8c8d;
  font-style: italic;
}

.rich-text img {
  max-width: 100%;
  height: auto;
  border-radius: 5px;
  margin: 20px 0;
}

/* 底部附件列表区域 */
footer {
  background: #f8f9fa;
  padding: 30px 40px;
  border-top: 1px solid #eee;
}

footer h3 {
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.attachment-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.attachment-item {
  background: white;
  padding: 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #eee;
  transition: all 0.2s ease;
}

.attachment-item:hover {
  border-color: #3498db;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.attachment-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.attachment-icon {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  background-color: #000;
}

.PDF {
  background-color: #e74c3c;
}

.XLSX,.XLS {
  background-color: #2ecc71;
}

.PPT {
  background-color: #f39c12;
}

.ZIP,.RAR, .GZ {
  background-color: #9b59b6;
}

.attachment-details h4 {
  font-size: 0.95rem;
  margin-bottom: 3px;
}

.attachment-details p {
  font-size: 0.8rem;
  color: #7f8c8d;
}

.download-btn {
  background: none;
  border: none;
  color: #3498db;
  cursor: pointer;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: color 0.2s ease;
}

.download-btn:hover {
  color: #2980b9;
}


/* 按钮区域样式 */
.button-group {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-top: 20px;
}

.later-btn, .confirm-btn {
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  flex: 1;
  max-width: 48%;
}

.later-btn {
  background-color: #f1f5f9;
  color: #334155;
}

.later-btn:hover {
  background-color: #e2e8f0;
}

.confirm-btn {
  background-color: #1890FF;
  color: white;
}

.confirm-btn:hover {
  background-color: #1890FF;
}

/deep/ .rich-text img{
  max-width: 100%;
  height: auto;
}

/* 响应式调整 */
@media (max-width: 600px) {
  header, main, footer {
    padding: 20px 15px;
  }

  header h1 {
    font-size: 1.5rem;
  }

  .header-meta {
    flex-direction: column;
    gap: 5px;
  }

  .attachment-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .button-group {
    flex-direction: column;
  }

  .later-btn, .confirm-btn {
    max-width: 100%;
    width: 100%;
  }
}
</style>